// @flow
import { connect } from "react-redux";

import type { ReduxState } from "../types";
import type { ComponentType } from "react";

type StateProps = {
  count: number,
  timestamp: number,
  percentComplete: number,
};

type Props = {
  ...StateProps,
  ...
};

/**
 */
const mapStateToProps = (state: ReduxState) => ({
  count: state.progressindicator.count,
  timestamp: state.progressindicator.timestamp,
  percentComplete: state.progressindicator.percentComplete,
});

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useProgressIndicatorState' instead
 */
export const connectProgressIndicator: ComponentType<any> = connect<
  Props,
  {},
  _,
  _,
  _,
  void,
>(mapStateToProps);
